export default __webpack_public_path__ + "static/media/322.44dc6d58.png";